export default __webpack_public_path__ + "static/media/plain-sticker-oi.f34bddbb.png";